export default {
    A1: {
        t: 's',
        v: '',
    },
    '!ref': 'A1:J1',
    '!merges': [{ s: { c: 0, r: 0 }, e: { c: 9, r: 0 } }],
};
